/**
 * CharacterJournalView — accepted journal entries for one character, grouped
 * by entry_type. Phase 7b. The long-running reference doc; the meeting page's
 * review pane is where pending entries land. This view is read-only.
 *
 * The smart wrapper here fetches the entries via React Query;
 * CharacterJournalViewView holds the actual rendering.
 */

import { useCompanyQuery } from "../../hooks/useCompanyQuery"
import { fetchJournalEntries } from "../../lib/api"
import { queryKeys } from "../../lib/query-keys"
import { CharacterJournalViewView } from "./CharacterJournalViewView"
import type { IProps } from "./interfaces"

export function CharacterJournalView({ seriesId, characterId, characterName }: IProps): React.JSX.Element {
  const journalQuery = useCompanyQuery({
    key: (org) => queryKeys.characterJournalAccepted(org, seriesId, characterId),
    queryFn: (company) => fetchJournalEntries(company, seriesId, { status: "accepted", characterId }),
  })

  return (
    <CharacterJournalViewView
      characterName={characterName}
      entries={journalQuery.data ?? []}
      isLoading={journalQuery.isLoading}
    />
  )
}
